import React, { Component } from 'react'
import SocialNetworking from './socialnetworking/SocialNetworkingContainer'
import MobileNavigationContainer from './mobileNavigation/MobileNavigationContainer'
import MediaQuery from 'react-responsive'
import styled from 'styled-components'

class NavigationContainer extends Component {
  render () {
    return (
    <>
      <MediaQuery query='(max-width: 768px)'>
        <MobileNavigationContainer
          goToSection={this.props.goToSection}
          menuItems={this.props.menuItems} />
      </MediaQuery>

      <MediaQuery query='(min-width: 769px)'>
        <div style={styles.navigationHeader}>
          {
            this.props.menuItems.map((item, index) => {
              return <b>
                <StyledLink
                  key={index} className={item.activeLink ? 'active' : ''} onClick={(e) => this.props.goToSection(item)}>
                  {item.displayHeader}
                </StyledLink></b>
            })
          }

          <SocialNetworking />

        </div>

      </MediaQuery>
</>
    )
  }
}

const StyledLink = styled.a`
background-color: #8D8741;
text-align: center;
padding: 14px 16px;
text-decoration: none;
font-size: px;
justify-content: center; 
align-items: center;
opacity: 1.0;
height: 100%;
float: left;
text-decoration: underline;
&:hover {
  background-color: #333;
  color: white;
  cursor: pointer;
  opacity: 1.0;
  height: 100%;
}
&:active {
  background-color: #4CAF50;
  color: #333;
  opacity: 1.0;
  height: 100%; 
}
`
const styles = {
  navigationHeader: {
    position: 'fixed',
    overflow: 'hidden',
    justifyContent: 'left',
    alignItems: 'left',
    float: 'left',
    top: 0,
    left: 0,
    height: '48px',
    width: '100%',
    backgroundColor: '#8D8741',
    borderTop: '2px black solid',
    borderBottom: '2px black solid',
    zIndex: 1
  }
}

export default NavigationContainer
